import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { testimonials } from "../mock";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];

  const next = () => setIdx((i) => (i + 1) % testimonials.length);
  const prev = () => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="py-24 lg:py-32" style={{ backgroundColor: "#e8a428" }}>
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-12">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#143527] mb-4">
            What Clients Say
          </p>
          <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1] text-[#143527] mb-4">
            Client Love
          </h2>
          <p className="text-[16px] text-[#143527]/80">
            Making facilities cleaner, calmer and more professional — one job at a time.
          </p>
        </div>

        <div className="relative">
          <div className="bg-[#f4ebde] rounded-3xl p-8 lg:p-14 shadow-lg min-h-[260px] flex flex-col justify-between">
            <Quote className="w-10 h-10 text-[#e8a428] mb-4" strokeWidth={1.4} />
            <p className="font-serif text-2xl lg:text-3xl leading-[1.35] text-[#143527] italic mb-8">
              {t.quote}
            </p>
            <div>
              <div className="font-semibold text-[#143527] text-base">{t.name}</div>
              <div className="text-sm text-[#143527]/65">{t.location}</div>
            </div>
          </div>

          <div className="flex items-center justify-between mt-6">
            <div className="flex gap-1.5">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  className={`h-1.5 rounded-full transition-all ${
                    i === idx ? "w-8 bg-[#143527]" : "w-1.5 bg-[#143527]/30"
                  }`}
                  aria-label={`Go to testimonial ${i + 1}`}
                />
              ))}
            </div>
            <div className="flex gap-2">
              <button
                onClick={prev}
                className="w-12 h-12 rounded-full bg-[#143527] text-[#f4ebde] flex items-center justify-center hover:bg-[#1f4d39] transition-colors"
                aria-label="Previous"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button
                onClick={next}
                className="w-12 h-12 rounded-full bg-[#143527] text-[#f4ebde] flex items-center justify-center hover:bg-[#1f4d39] transition-colors"
                aria-label="Next"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
